import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Dueños de gatos que viven en departamentos y temen caídas o ingesta de objetos.', 'Personas que rescataron un michi y quieren estar preparadas para lo inesperado.', 'Padres de gatos que viven lejos de una veterinaria 24hs.', 'Cualquiera que considere a su gato como parte de la familia y no quiera fallarle.'];
  const notFor = ['Personas que buscan diagnósticos para evitar ir al veterinario (esta guía es para estabilizar, no para reemplazar al médico).', 'Quienes creen que un gato "se cura solo" lamiéndose las heridas.'];
  return <section className="py-8 md:py-12 px-4 bg-neutral-900" data-id="element-411">
      <div className="container mx-auto max-w-5xl" data-id="element-412">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-413">
          {/* Para vos si... */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-neutral-950 border border-green-500/20 rounded-2xl p-6 md:p-10" data-id="element-414">
            <h3 className="text-2xl font-display text-white mb-5 flex items-center gap-3" data-id="element-415">
              <CheckCircle2 className="text-green-500" size={32} data-id="element-416" />
              Esta guía ES para vos si...
            </h3>
            <ul className="space-y-4" data-id="element-417">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-418">
                  <div className="mt-1 bg-green-500/10 p-1 rounded-full text-green-500 shrink-0" data-id="element-419">
                    <CheckCircle2 size={18} data-id="element-420" />
                  </div>
                  <p className="text-neutral-300 text-lg leading-relaxed" data-id="element-421">
                    {item}
                  </p>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para vos si... */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-neutral-950 border border-red-500/20 rounded-2xl p-6 md:p-10" data-id="element-422">
            <h3 className="text-2xl font-display text-white mb-5 flex items-center gap-3" data-id="element-423">
              <XCircle className="text-red-500" size={32} data-id="element-424" />
              NO es para vos si...
            </h3>
            <ul className="space-y-4" data-id="element-425">
              {notFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-426">
                  <div className="mt-1 bg-red-500/10 p-1 rounded-full text-red-500 shrink-0" data-id="element-427">
                    <XCircle size={18} data-id="element-428" />
                  </div>
                  <p className="text-neutral-400 text-lg leading-relaxed" data-id="element-429">
                    {item}
                  </p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}